import moment from 'moment';
import React, { useEffect, useRef, useState } from 'react'
import { useTranslation } from 'react-i18next';
import { useLocation, useNavigate } from 'react-router-dom';
import pdflogoSrc from './../assets/images/pdf_logo.jpeg';
import './../css/ViewMaterial.css';

function ViewMaterial() {
    const location = useLocation();
    const { t } = useTranslation();
    const MorningeffectRan = useRef(false);
    const navigate = useNavigate();
    const [MorningData, setMorningData] = useState({
        vegetable: [],
        grocery: [],
        dairy: [],
        farsan: [],
        vasan: []
    });

    const AfternooneffectRan = useRef(false);
    const [AfternoonData, setAfternoonData] = useState({
        vegetable: [],
        grocery: [],
        dairy: [],
        farsan: [],
        vasan: []
    });

    const NighteffectRan = useRef(false);
    const [NightData, setNightData] = useState({
        vegetable: [],
        grocery: [],
        dairy: [],
        farsan: [],
        vasan: []
    });

    const {
        selectedOrder,
        inputValue,
        morningOptions,
        afternoonselectedOptions,
        nightSelectedOptions
    } = location.state || {};

    useEffect(() => {
        if (!MorningeffectRan.current && morningOptions && morningOptions.length > 0) {
            const updatedMorningData = { ...MorningData };
            morningOptions.forEach((element) => {

                // if (element.items.vegetable && element.items.vegetable.length > 0) {
                //     element.items.vegetable.forEach((item) => {
                //         const quantity = Number(item.quantity);
                //         const index = updatedMorningData.vegetable.findIndex((x) => x.vegetable.name === item.vegetable.name);

                //         if (index !== -1) {
                //             updatedMorningData.vegetable[index].quantity += quantity;
                //         } else {
                //             updatedMorningData.vegetable.push({ ...item, quantity });
                //         }
                //     });
                // }

                if (element.items.vegetable && element.items.vegetable.length > 0) {

                    element.items.vegetable.forEach((item) => {

                        let quantity = Number(item.quantity);
                        let unitType = item.unitType.toLowerCase();

                        if (unitType === 'kgs') {
                            quantity = quantity * 1000;
                            unitType = 'Gram';
                        }

                        const index = updatedMorningData.vegetable.findIndex(
                            (x) => x.vegetable.name === item.vegetable.name
                        );
                        if (index !== -1) {
                            updatedMorningData.vegetable[index].quantity += quantity;
                        } else {
                            updatedMorningData.vegetable.push({
                                ...item,
                                quantity,
                                unitType
                            });
                        }
                    });
                }

                if (element.items.grocery && element.items.grocery.length > 0) {
                    element.items.grocery.forEach((item) => {
                        let quantity = Number(item.quantity);
                        let unitType = item.unitType.toLowerCase();

                        if (unitType === 'ml') {
                            quantity = quantity / 1000;
                            unitType = 'Liter';
                        }

                        const index = updatedMorningData.grocery.findIndex(
                            (x) => x.grocery.name === item.grocery.name
                        );

                        if (index !== -1) {
                            updatedMorningData.grocery[index].quantity += quantity;
                        } else {
                            updatedMorningData.grocery.push({
                                ...item,
                                quantity,
                                unitType
                            });
                        }
                    });

                }

                if (element.items.dairy && element.items.dairy.length > 0) {
                    element.items.dairy.forEach((item) => {
                        // const quantity = Number(item.quantity);
                        // const index = updatedMorningData.dairy.findIndex((x) => x.dairy.name === item.dairy.name);

                        // if (index !== -1) {
                        //     updatedMorningData.dairy[index].quantity += quantity;
                        // } else {
                        //     updatedMorningData.dairy.push({ ...item, quantity });
                        // }

                        let quantity = Number(item.quantity);
                        let unitType = item.unitType.toLowerCase();


                        if (unitType === 'ml') {
                            quantity = quantity / 1000;
                            unitType = 'Liter';
                        }

                        const index = updatedMorningData.dairy.findIndex(
                            (x) => x.dairy.name === item.dairy.name
                        );

                        if (index !== -1) {
                            updatedMorningData.dairy[index].quantity += quantity;
                        } else {
                            updatedMorningData.dairy.push({
                                ...item,
                                quantity,
                                unitType
                            });
                        }
                    });
                }

                if (element.items.farsan && element.items.farsan.length > 0) {
                    element.items.farsan.forEach((item) => {
                        // const quantity = Number(item.quantity);
                        // const index = updatedMorningData.farsan.findIndex((x) => x.farsan.name === item.farsan.name);

                        // if (index !== -1) {
                        //     updatedMorningData.farsan[index].quantity += quantity;
                        // } else {
                        //     updatedMorningData.farsan.push({ ...item, quantity });
                        // }

                        let quantity = Number(item.quantity);
                        let unitType = item.unitType.toLowerCase();

                        if (unitType === 'kgs') {
                            quantity = quantity * 1000;
                            unitType = 'Gram';
                        }

                        const index = updatedMorningData.farsan.findIndex(
                            (x) => x.farsan.name === item.farsan.name
                        );

                        if (index !== -1) {
                            updatedMorningData.farsan[index].quantity += quantity;
                        } else {
                            updatedMorningData.farsan.push({
                                ...item,
                                quantity,
                                unitType
                            });
                        }
                    });
                }

                if (element.items.vasan && element.items.vasan.length > 0) {
                    element.items.vasan.forEach((item) => {

                        const quantity = Number(item.quantity);
                        const index = updatedMorningData.vasan.findIndex((x) => x.vasan.name === item.vasan.name);

                        if (index !== -1) {
                            updatedMorningData.vasan[index].quantity += quantity;
                        } else {
                            updatedMorningData.vasan.push({ ...item, quantity });
                        }
                    });
                }
            });
            setMorningData(updatedMorningData);
            MorningeffectRan.current = true;
        }

        if (!AfternooneffectRan.current && afternoonselectedOptions && afternoonselectedOptions.length > 0) {
            const updatedAfternoonData = { ...AfternoonData };

            afternoonselectedOptions.forEach((element) => {
                if (element.items.vegetable && element.items.vegetable.length > 0) {
                    element.items.vegetable.forEach((item) => {
                        // const quantity = Number(item.quantity);
                        // const index = updatedAfternoonData.vegetable.findIndex((x) => x.vegetable.name === item.vegetable.name);

                        // if (index !== -1) {
                        //     updatedAfternoonData.vegetable[index].quantity += quantity;
                        // } else {
                        //     updatedAfternoonData.vegetable.push({ ...item, quantity });
                        // }

                        let quantity = Number(item.quantity);
                        let unitType = item.unitType.toLowerCase();

                        if (unitType === 'kgs') {
                            quantity = quantity * 1000;
                            unitType = 'Gram';
                        }

                        const index = updatedAfternoonData.vegetable.findIndex(
                            (x) => x.vegetable.name === item.vegetable.name
                        );

                        if (index !== -1) {
                            updatedAfternoonData.vegetable[index].quantity += quantity;
                        } else {
                            updatedAfternoonData.vegetable.push({
                                ...item,
                                quantity,
                                unitType
                            });
                        }
                    });
                }

                if (element.items.grocery && element.items.grocery.length > 0) {
                    element.items.grocery.forEach((item) => {
                        // const quantity = Number(item.quantity);
                        // const index = updatedAfternoonData.grocery.findIndex((x) => x.grocery.name === item.grocery.name);

                        // if (index !== -1) {
                        //     updatedAfternoonData.grocery[index].quantity += quantity;
                        // } else {
                        //     updatedAfternoonData.grocery.push({ ...item, quantity });
                        // }

                        let quantity = Number(item.quantity);
                        let unitType = item.unitType.toLowerCase();


                        if (unitType === 'ml') {
                            quantity = quantity / 1000;
                            unitType = 'Liter';
                        }

                        const index = updatedAfternoonData.grocery.findIndex(
                            (x) => x.grocery.name === item.grocery.name
                        );

                        if (index !== -1) {
                            updatedAfternoonData.grocery[index].quantity += quantity;
                        } else {
                            updatedAfternoonData.grocery.push({
                                ...item,
                                quantity,
                                unitType
                            });
                        }
                    });
                }

                if (element.items.dairy && element.items.dairy.length > 0) {
                    element.items.dairy.forEach((item) => {
                        // const quantity = Number(item.quantity);
                        // const index = updatedAfternoonData.dairy.findIndex((x) => x.dairy.name === item.dairy.name);

                        // if (index !== -1) {
                        //     updatedAfternoonData.dairy[index].quantity += quantity;
                        // } else {
                        //     updatedAfternoonData.dairy.push({ ...item, quantity });
                        // }

                        let quantity = Number(item.quantity);
                        let unitType = item.unitType.toLowerCase();


                        if (unitType === 'ml') {
                            quantity = quantity / 1000;
                            unitType = 'Liter';
                        }

                        const index = updatedAfternoonData.dairy.findIndex(
                            (x) => x.dairy.name === item.dairy.name
                        );

                        if (index !== -1) {
                            updatedAfternoonData.dairy[index].quantity += quantity;
                        } else {
                            updatedAfternoonData.dairy.push({
                                ...item,
                                quantity,
                                unitType
                            });
                        }
                    });
                }

                if (element.items.farsan && element.items.farsan.length > 0) {
                    element.items.farsan.forEach((item) => {
                        // const quantity = Number(item.quantity);
                        // const index = updatedAfternoonData.farsan.findIndex((x) => x.farsan.name === item.farsan.name);

                        // if (index !== -1) {
                        //     updatedAfternoonData.farsan[index].quantity += quantity;
                        // } else {
                        //     updatedAfternoonData.farsan.push({ ...item, quantity });
                        // }

                        let quantity = Number(item.quantity);
                        let unitType = item.unitType.toLowerCase();

                        if (unitType === 'kgs') {
                            quantity = quantity * 1000;
                            unitType = 'Gram';
                        }

                        const index = updatedAfternoonData.farsan.findIndex(
                            (x) => x.farsan.name === item.farsan.name
                        );

                        if (index !== -1) {
                            updatedAfternoonData.farsan[index].quantity += quantity;
                        } else {
                            updatedAfternoonData.farsan.push({
                                ...item,
                                quantity,
                                unitType
                            });
                        }
                    });
                }

                if (element.items.vasan && element.items.vasan.length > 0) {
                    element.items.vasan.forEach((item) => {
                        const quantity = Number(item.quantity);
                        const index = updatedAfternoonData.vasan.findIndex((x) => x.vasan.name === item.vasan.name);
                        if (index !== -1) {
                            updatedAfternoonData.vasan[index].quantity += quantity;
                        } else {
                            updatedAfternoonData.vasan.push({ ...item, quantity });
                        }
                    });
                }
            });
            setAfternoonData(updatedAfternoonData);
            AfternooneffectRan.current = true;
        }

        if (!NighteffectRan.current && nightSelectedOptions && nightSelectedOptions.length > 0) {
            const updatedNightData = { ...NightData };

            nightSelectedOptions.forEach((element) => {
                if (element.items.vegetable && element.items.vegetable.length > 0) {
                    element.items.vegetable.forEach((item) => {
                        // const quantity = Number(item.quantity);
                        // const index = updatedNightData.vegetable.findIndex((x) => x.vegetable.name === item.vegetable.name);

                        // if (index !== -1) {
                        //     updatedNightData.vegetable[index].quantity += quantity;
                        // } else {
                        //     updatedNightData.vegetable.push({ ...item, quantity });
                        // }

                        let quantity = Number(item.quantity);
                        let unitType = item.unitType.toLowerCase();

                        if (unitType === 'kgs') {
                            quantity = quantity * 1000;
                            unitType = 'Gram';
                        }

                        const index = updatedNightData.vegetable.findIndex(
                            (x) => x.vegetable.name === item.vegetable.name
                        );

                        if (index !== -1) {
                            updatedNightData.vegetable[index].quantity += quantity;
                        } else {
                            updatedNightData.vegetable.push({
                                ...item,
                                quantity,
                                unitType
                            });
                        }
                    });
                }

                if (element.items.grocery && element.items.grocery.length > 0) {
                    element.items.grocery.forEach((item) => {
                        // const quantity = Number(item.quantity);
                        // const index = updatedNightData.grocery.findIndex((x) => x.grocery.name === item.grocery.name);

                        // if (index !== -1) {
                        //     updatedNightData.grocery[index].quantity += quantity;
                        // } else {
                        //     updatedNightData.grocery.push({ ...item, quantity });
                        // }

                        let quantity = Number(item.quantity);
                        let unitType = item.unitType.toLowerCase();


                        if (unitType === 'ml') {
                            quantity = quantity / 1000;
                            unitType = 'Liter';
                        }

                        const index = updatedNightData.grocery.findIndex(
                            (x) => x.grocery.name === item.grocery.name
                        );

                        if (index !== -1) {
                            updatedNightData.grocery[index].quantity += quantity;
                        } else {
                            updatedNightData.grocery.push({
                                ...item,
                                quantity,
                                unitType
                            });
                        }
                    });
                }

                if (element.items.dairy && element.items.dairy.length > 0) {
                    element.items.dairy.forEach((item) => {
                        // const quantity = Number(item.quantity);
                        // const index = updatedNightData.dairy.findIndex((x) => x.dairy.name === item.dairy.name);

                        // if (index !== -1) {
                        //     updatedNightData.dairy[index].quantity += quantity;
                        // } else {
                        //     updatedNightData.dairy.push({ ...item, quantity });
                        // }

                        let quantity = Number(item.quantity);
                        let unitType = item.unitType.toLowerCase();


                        if (unitType === 'ml') {
                            quantity = quantity / 1000;
                            unitType = 'Liter';
                        }

                        const index = updatedNightData.dairy.findIndex(
                            (x) => x.dairy.name === item.dairy.name
                        );

                        if (index !== -1) {
                            updatedNightData.dairy[index].quantity += quantity;
                        } else {
                            updatedNightData.dairy.push({
                                ...item,
                                quantity,
                                unitType
                            });
                        }
                    });
                }

                if (element.items.farsan && element.items.farsan.length > 0) {
                    element.items.farsan.forEach((item) => {
                        // const quantity = Number(item.quantity);
                        // const index = updatedNightData.farsan.findIndex((x) => x.farsan.name === item.farsan.name);

                        // if (index !== -1) {
                        //     updatedNightData.farsan[index].quantity += quantity;
                        // } else {
                        //     updatedNightData.farsan.push({ ...item, quantity });
                        // }

                        let quantity = Number(item.quantity);
                        let unitType = item.unitType.toLowerCase();

                        if (unitType === 'kgs') {
                            quantity = quantity * 1000;
                            unitType = 'Gram';
                        }

                        const index = updatedNightData.farsan.findIndex(
                            (x) => x.farsan.name === item.farsan.name
                        );

                        if (index !== -1) {
                            updatedNightData.farsan[index].quantity += quantity;
                        } else {
                            updatedNightData.farsan.push({
                                ...item,
                                quantity,
                                unitType
                            });
                        }
                    });
                }

                if (element.items.vasan && element.items.vasan.length > 0) {
                    element.items.vasan.forEach((item) => {
                        const quantity = Number(item.quantity);
                        const index = updatedNightData.vasan.findIndex((x) => x.vasan.name === item.vasan.name);

                        if (index !== -1) {
                            updatedNightData.vasan[index].quantity += quantity;
                        }
                        else {
                            updatedNightData.vasan.push({ ...item, quantity });
                        }
                    });
                }
            });
            setNightData(updatedNightData);
            NighteffectRan.current = true;
        }

    }, [morningOptions, afternoonselectedOptions, nightSelectedOptions]);

    const handlePrint = () => {
        window.print();
    }

    function calculate(initialItem, targetPeople, unitType) {
        // return (initialItem / 100) * targetPeople;

        let result = unitType.toLowerCase() === 'per_person' ? initialItem : (initialItem / 100) * targetPeople;

        if (unitType.toLowerCase() === 'gram' && result >= 1000) {
            result = result / 1000;

            if (result % 1 !== 0) {
                result = result.toFixed(3);
            }

            return result + ' કિગ્રા (KGS)';
        }

        if (unitType.toLowerCase() === 'gram' && result < 1000) {
            result = Math.round(result)
        }

        if (unitType.toLowerCase() === 'ml' && result >= 1000) {
            result = result / 1000;
            return result + ' લિટર (Liter)';
        }

        if (unitType.toLowerCase() === 'kgs') {
            if (result % 1 !== 0) {
                result = result.toFixed(3);
            }
            return Math.round(result) + ' કિગ્રા (KGS)';
        }

        if(unitType.toLowerCase() === 'liter'){
            if (result % 1 !== 0) {
                result = result.toFixed(3);
            }
            return Math.round(result) + ' લિટર (Liter)';
        }

        if (unitType.toLowerCase() === 'pieces') {
            return Math.round(result) + ' નંગ (Pieces)';
        }

        let unittype = '';
        if (unitType.toLowerCase() === 'gram') {
            unittype = 'ગ્રામ (Gram)'
        } else if (unitType.toLowerCase() === 'ml') {
            unittype = 'મિલીલીટર (ML)'
        } else if (unitType.toLowerCase() === 'liter') {
            unittype = 'લિટર (Liter)'
        } else if (unitType.toLowerCase() === 'kgs') {
            unittype = 'કિગ્રા (KGS)'
        } else if (unitType.toLowerCase() === 'pieces') {
            unittype = 'નંગ (Pieces)'
        } else if (unitType.toLowerCase() === 'per_person') {
            unittype = 'માણસો દીઠ (Per Person)'
        }

        return result + ' ' + unittype;
    }

    return (
        <div className='m-auto w-[800px] bg-[#ffffff]'>

            <div className='printbtn gap-4' style={{ display: 'flex', justifyContent: 'center', padding: '10px' }}>
                <button className='flex items-center justify-center text-[14px] h-[30px] w-[70px]' style={{ border: '1px solid', paddingLeft: '10px', paddingRight: '10px', borderRadius: '5px' }}
                    onClick={() => {
                        navigate(-1)
                    }}
                >{t('btnCancel')}
                </button>
                <button className='flex items-center justify-center text-[14px] h-[30px] w-[70px]' style={{ border: '1px solid', paddingLeft: '10px', paddingRight: '10px', borderRadius: '5px' }} onClick={handlePrint}>{t('btnPrint')}</button>
            </div>

            {MorningData && (MorningData.dairy.length > 0 ||
                MorningData.vegetable.length > 0 ||
                MorningData.farsan.length > 0 ||
                MorningData.grocery.length > 0 ||
                MorningData.vasan.length > 0) && (<>
                    <div style={{
                        display: 'flex',
                        flexWrap: 'wrap',
                        color: '#000000',
                        justifyContent: 'space-between',
                        border: '2px solid #14312c',
                        //backgroundColor: '#4f726c'
                    }}>
                        <div style={{ width: '78%' }}>
                            <div style={{
                                marginBottom: '0px',
                                padding: '0px',
                                paddingTop: '15px',
                                display: 'flex',
                                justifyContent: 'space-between',
                                flexWrap: 'wrap',
                                fontSize: '14px',
                            }}>
                                <div style={{ paddingLeft: '15px', width: '46%', marginBottom: '10px' }}><strong>{t('Farm_Name')}:</strong> {selectedOrder.farmName}</div>
                                <div style={{ paddingRight: '15px', width: '46%', marginBottom: '10px' }}><strong>{t('Party_Name')}:</strong> {selectedOrder.partyName}</div>
                                <div style={{ paddingLeft: '15px', width: '46%', marginBottom: '10px' }}><strong>{t('Contact_Number')}:</strong> {selectedOrder.contactNumber}</div>
                                <div style={{ paddingRight: '15px', width: '46%', marginBottom: '10px' }}><strong>{t('Event_Date')}:</strong> {moment(selectedOrder.eventDate).format('DD-MM-YYYY')}</div>
                                <div style={{ width: '100%', paddingLeft: '15px', paddingRight: '15px', marginBottom: '10px' }}><strong>{t('Farm_Address')}:</strong> {selectedOrder.farmAddress}</div>
                            </div>
                        </div>
                        <div style={{
                            width: '20%',
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                            marginRight: '3px'
                        }}>
                            <div style={{ textAlign: 'center' }}>
                                <img src={pdflogoSrc} alt='Logo' style={{ width: '100px' }} />
                            </div>
                        </div>

                        <div style={{
                            display: 'flex',
                            flexWrap: 'wrap',
                            // backgroundColor: '#14312c',
                            width: '100%',
                            justifyContent: 'space-between',
                            padding: '10px 15px',
                            margin: 'auto',
                            marginBottom: '0px'
                        }}>
                            <div style={{ marginBottom: '0px' }}>
                                <strong>{moment(selectedOrder.eventDate).format('DD-MM-YYYY')} :</strong> - {t('Morning')}
                            </div>
                            <div style={{ marginBottom: '0px' }}>
                                <strong>{t('dish')} :-</strong> {inputValue.mTotalPerson ? inputValue.mTotalPerson : 0}
                            </div>
                        </div>
                    </div>
                    <div style={{ margin: '10px 0' }} >
                        <div style={{ padding: '15px 0px' }} class="menu-items">
                            {MorningData.vegetable && MorningData.vegetable.length > 0 && (<>
                                <div style={{
                                    fontWeight: 'bold',
                                    paddingTop: '5px',
                                    paddingBottom: '5px',
                                    fontSize: '14px',
                                    display: 'flex',
                                    justifyContent: 'center',
                                    color: '#000000'
                                }}>
                                    {t('vegetable')}
                                </div>
                                <table style={{ width: '100%', fontSize: '12px' }}>
                                    <thead>
                                        <tr style={{
                                            color: '#000000'
                                        }}>
                                            <th style={{ padding: '10px', textAlign: 'left', width: '22%' }}>{t('no')}</th>
                                            <th style={{ padding: '10px', textAlign: 'left', width: '40%' }}>{t('item')}</th>
                                            <th style={{ padding: '10px', textAlign: 'left', width: '38%' }}>{t('Quantity')}</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {MorningData.vegetable.map((item, index) => (
                                            <tr key={index} style={{
                                                //backgroundColor: '#f9f9fb' 
                                            }}>
                                                <td style={{ padding: '10px', width: '22%' }}>{index + 1}</td>
                                                <td style={{ padding: '10px', width: '40%' }}>{item.vegetable.name}</td>
                                                <td style={{ padding: '10px', width: '38%' }}>{calculate(item.quantity, inputValue.mTotalPerson, item.unitType)}</td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </>)}

                            {MorningData.grocery && MorningData.grocery.length > 0 && (<>
                                <div style={{
                                    fontWeight: 'bold',
                                    paddingTop: '5px',
                                    paddingBottom: '5px',
                                    fontSize: '14px',
                                    display: 'flex',
                                    justifyContent: 'center',
                                    // backgroundColor: '#4f726c',
                                    color: '#000000',
                                    marginTop: '20px'
                                }}>
                                    {t('Groceries')}
                                </div>
                                <table style={{ width: '100%', fontSize: '12px' }}>
                                    <thead>
                                        <tr style={{
                                            // backgroundColor: '#14312c', 
                                            color: '#000000'
                                        }}>
                                            <th style={{ padding: '10px', textAlign: 'left', width: '22%' }}>{t('no')}</th>
                                            <th style={{ padding: '10px', textAlign: 'left', width: '40%' }}>{t('item')}</th>
                                            <th style={{ padding: '10px', textAlign: 'left', width: '38%' }}>{t('Quantity')}</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {MorningData.grocery.map((item, index) => (
                                            <tr key={index}
                                            // style={{ backgroundColor: '#f9f9fb' }}
                                            >
                                                <td style={{ padding: '10px', width: '22%' }}>{index + 1}</td>
                                                <td style={{ padding: '10px', width: '40%' }}>{item.grocery.name}</td>
                                                <td style={{ padding: '10px', width: '38%' }}>{calculate(item.quantity, inputValue.mTotalPerson, item.unitType)}</td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </>)}

                            {MorningData.dairy && MorningData.dairy.length > 0 && (<>
                                <div style={{
                                    fontWeight: 'bold',
                                    paddingTop: '5px',
                                    paddingBottom: '5px',
                                    fontSize: '14px',
                                    display: 'flex',
                                    justifyContent: 'center',
                                    //backgroundColor: '#4f726c',
                                    color: '#000000',
                                    marginTop: '20px'
                                }}>
                                    {t('DairyItems')}
                                </div>
                                <table style={{ width: '100%', fontSize: '12px' }}>
                                    <thead>
                                        <tr style={{
                                            // backgroundColor: '#14312c', 
                                            color: '#000000'
                                        }}>
                                            <th style={{ padding: '10px', textAlign: 'left', width: '22%' }}>{t('no')}</th>
                                            <th style={{ padding: '10px', textAlign: 'left', width: '40%' }}>{t('item')}</th>
                                            <th style={{ padding: '10px', textAlign: 'left', width: '38%' }}>{t('Quantity')}</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {MorningData.dairy.map((item, index) => (
                                            <tr key={index}
                                            //  style={{ backgroundColor: '#f9f9fb' }}
                                            >
                                                <td style={{ padding: '10px', width: '22%' }}>{index + 1}</td>
                                                <td style={{ padding: '10px', width: '40%' }}>{item.dairy.name}</td>
                                                <td style={{ padding: '10px', width: '38%' }}>{calculate(item.quantity, inputValue.mTotalPerson, item.unitType)}</td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </>)}


                            {MorningData.farsan && MorningData.farsan.length > 0 && (<>
                                <div style={{
                                    fontWeight: 'bold',
                                    paddingTop: '5px',
                                    paddingBottom: '5px',
                                    fontSize: '14px',
                                    display: 'flex',
                                    justifyContent: 'center',
                                    //  backgroundColor: '#4f726c',
                                    color: '#000000',
                                    marginTop: '20px'
                                }}>
                                    {t('FarsanItems')}
                                </div>
                                <table style={{ width: '100%', fontSize: '12px' }}>
                                    <thead>
                                        <tr style={{
                                            //backgroundColor: '#14312c',
                                            color: '#000000'
                                        }}>
                                            <th style={{ padding: '10px', textAlign: 'left', width: '22%' }}>{t('no')}</th>
                                            <th style={{ padding: '10px', textAlign: 'left', width: '40%' }}>{t('item')}</th>
                                            <th style={{ padding: '10px', textAlign: 'left', width: '38%' }}>{t('Quantity')}</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {MorningData.farsan.map((item, index) => (
                                            <tr key={index}
                                            // style={{ backgroundColor: '#f9f9fb' }}
                                            >
                                                <td style={{ padding: '10px', width: '22%' }}>{index + 1}</td>
                                                <td style={{ padding: '10px', width: '40%' }}>{item.farsan.name}</td>
                                                <td style={{ padding: '10px', width: '38%' }}>{calculate(item.quantity, inputValue.mTotalPerson, item.unitType)}</td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </>)}

                            {MorningData.vasan && MorningData.vasan.length > 0 && (<>
                                <div style={{
                                    fontWeight: 'bold',
                                    paddingTop: '5px',
                                    paddingBottom: '5px',
                                    fontSize: '14px',
                                    display: 'flex',
                                    justifyContent: 'center',
                                    // backgroundColor: '#4f726c',
                                    color: '#000000',
                                    marginTop: '20px'
                                }}>
                                    {t('VasanItems')}
                                </div>
                                <table style={{ width: '100%', fontSize: '12px' }}>
                                    <thead>
                                        <tr style={{
                                            // backgroundColor: '#14312c', 
                                            color: '#000000'
                                        }}>
                                            <th style={{ padding: '10px', textAlign: 'left', width: '22%' }}>{t('no')}</th>
                                            <th style={{ padding: '10px', textAlign: 'left', width: '40%' }}>{t('item')}</th>
                                            <th style={{ padding: '10px', textAlign: 'left', width: '38%' }}>{t('Quantity')}</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {MorningData.vasan.map((item, index) => (
                                            <tr key={index}
                                            //style={{ backgroundColor: '#f9f9fb' }}
                                            >
                                                <td style={{ padding: '10px', width: '22%' }}>{index + 1}</td>
                                                <td style={{ padding: '10px', width: '40%' }}>{item.vasan.name}</td>
                                                <td style={{ padding: '10px', width: '38%' }}>{calculate(item.quantity, inputValue.mTotalPerson, item.unitType)}</td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </>)}
                            {/* </>))} */}
                        </div>
                    </div>

                    {afternoonselectedOptions && afternoonselectedOptions.length > 0 &&
                        <div style={{ pageBreakBefore: 'always' }}></div>}
                </>)}

            {AfternoonData && (AfternoonData.dairy.length > 0 ||
                AfternoonData.vegetable.length > 0 ||
                AfternoonData.farsan.length > 0 ||
                AfternoonData.grocery.length > 0 ||
                AfternoonData.vasan.length > 0) && (<>
                    <div style={{
                        display: 'flex',
                        flexWrap: 'wrap',
                        color: '#000000',
                        justifyContent: 'space-between',
                        border: '2px solid #14312c',
                        // backgroundColor: '#4f726c'
                    }}>
                        <div style={{ width: '78%' }}>
                            <div style={{
                                marginBottom: '0px',
                                padding: '0px',
                                paddingTop: '15px',
                                display: 'flex',
                                justifyContent: 'space-between',
                                flexWrap: 'wrap',
                                fontSize: '14px',
                            }}>
                                <div style={{ paddingLeft: '15px', width: '46%', marginBottom: '10px' }}><strong>{t('Farm_Name')}:</strong> {selectedOrder.farmName}</div>
                                <div style={{ paddingRight: '15px', width: '46%', marginBottom: '10px' }}><strong>{t('Party_Name')}:</strong> {selectedOrder.partyName}</div>
                                <div style={{ paddingLeft: '15px', width: '46%', marginBottom: '10px' }}><strong>{t('Contact_Number')}:</strong> {selectedOrder.contactNumber}</div>
                                <div style={{ paddingRight: '15px', width: '46%', marginBottom: '10px' }}><strong>{t('Event_Date')}:</strong> {moment(selectedOrder.eventDate).format('DD-MM-YYYY')}</div>
                                <div style={{ width: '100%', paddingLeft: '15px', paddingRight: '15px', marginBottom: '10px' }}><strong>{t('Farm_Address')}:</strong> {selectedOrder.farmAddress}</div>
                            </div>
                        </div>
                        <div style={{
                            width: '20%',
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                            marginRight: '3px'
                        }}>
                            <div style={{ textAlign: 'center' }}>
                                <img src={pdflogoSrc} alt='Logo' style={{ width: '100px' }} />
                            </div>
                        </div>

                        <div style={{
                            display: 'flex',
                            flexWrap: 'wrap',
                            // backgroundColor: '#14312c',
                            width: '100%',
                            justifyContent: 'space-between',
                            padding: '10px 15px',
                            margin: 'auto',
                            marginBottom: '0px'
                        }}>
                            <div style={{ marginBottom: '0px' }}>
                                <strong>{moment(selectedOrder.eventDate).format('DD-MM-YYYY')} :</strong> - {t('Afternoon')}
                            </div>
                            <div style={{ marginBottom: '0px' }}>
                                <strong>{t('dish')} :-</strong> {inputValue.aTotalPerson ? inputValue.aTotalPerson : 0}
                            </div>
                        </div>
                    </div>

                    <div style={{ margin: '10px 0' }} >
                        <div style={{ padding: '15px 0px' }} class="menu-items">
                            {/* {afternoonselectedOptions.map((element, indx) => (<> */}
                            {/* <div style={{ fontWeight: 'bold', paddingTop: '5px', paddingBottom: '5px', fontSize: '16px' }}>
                                {indx + 1 + '.'} {element.menuName}
                            </div> */}

                            {AfternoonData.vegetable && AfternoonData.vegetable.length > 0 && (<>
                                <div style={{
                                    fontWeight: 'bold',
                                    paddingTop: '5px',
                                    paddingBottom: '5px',
                                    fontSize: '14px',
                                    display: 'flex',
                                    justifyContent: 'center',
                                    // backgroundColor: '#4f726c',
                                    color: '#000000'
                                }}>
                                    {t('vegetable')}
                                </div>
                                <table style={{ width: '100%', fontSize: '12px' }}>
                                    <thead>
                                        <tr style={{
                                            //backgroundColor: '#14312c',
                                            color: '#000000'
                                        }}>
                                            <th style={{ padding: '10px', textAlign: 'left', width: '22%' }}>{t('no')}</th>
                                            <th style={{ padding: '10px', textAlign: 'left', width: '40%' }}>{t('item')}</th>
                                            <th style={{ padding: '10px', textAlign: 'left', width: '38%' }}>{t('Quantity')}</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {AfternoonData.vegetable.map((item, index) => (
                                            <tr key={index}
                                            //style={{ backgroundColor: '#f9f9fb' }}
                                            >
                                                <td style={{ padding: '10px', width: '22%' }}>{index + 1}</td>
                                                <td style={{ padding: '10px', width: '40%' }}>{item.vegetable.name}</td>
                                                <td style={{ padding: '10px', width: '38%' }}>{calculate(item.quantity, inputValue.aTotalPerson, item.unitType)}</td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </>)}

                            {AfternoonData.grocery && AfternoonData.grocery.length > 0 && (<>
                                <div style={{
                                    fontWeight: 'bold',
                                    paddingTop: '5px',
                                    paddingBottom: '5px',
                                    fontSize: '14px',
                                    display: 'flex',
                                    justifyContent: 'center',
                                    // backgroundColor: '#4f726c',
                                    color: '#000000',
                                    marginTop: '20px'
                                }}>
                                    {t('Groceries')}
                                </div>
                                <table style={{ width: '100%', fontSize: '12px' }}>
                                    <thead>
                                        <tr style={{
                                            //backgroundColor: '#14312c', 
                                            color: '#000000'
                                        }}>
                                            <th style={{ padding: '10px', textAlign: 'left', width: '22%' }}>{t('no')}</th>
                                            <th style={{ padding: '10px', textAlign: 'left', width: '40%' }}>{t('item')}</th>
                                            <th style={{ padding: '10px', textAlign: 'left', width: '38%' }}>{t('Quantity')}</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {AfternoonData.grocery.map((item, index) => (
                                            <tr key={index}
                                            //style={{ backgroundColor: '#f9f9fb' }}
                                            >
                                                <td style={{ padding: '10px', width: '22%' }}>{index + 1}</td>
                                                <td style={{ padding: '10px', width: '40%' }}>{item.grocery.name}</td>
                                                <td style={{ padding: '10px', width: '38%' }}>{calculate(item.quantity, inputValue.aTotalPerson, item.unitType)}</td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </>)}

                            {AfternoonData.dairy && AfternoonData.dairy.length > 0 && (<>
                                <div style={{
                                    fontWeight: 'bold',
                                    paddingTop: '5px',
                                    paddingBottom: '5px',
                                    fontSize: '14px',
                                    display: 'flex',
                                    justifyContent: 'center',
                                    // backgroundColor: '#4f726c',
                                    color: '#000000',
                                    marginTop: '20px'
                                }}>
                                    {t('DairyItems')}
                                </div>
                                <table style={{ width: '100%', fontSize: '12px' }}>
                                    <thead>
                                        <tr style={{
                                            //backgroundColor: '#14312c', 
                                            color: '#000000'
                                        }}>
                                            <th style={{ padding: '10px', textAlign: 'left', width: '22%' }}>{t('no')}</th>
                                            <th style={{ padding: '10px', textAlign: 'left', width: '40%' }}>{t('item')}</th>
                                            <th style={{ padding: '10px', textAlign: 'left', width: '38%' }}>{t('Quantity')}</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {AfternoonData.dairy.map((item, index) => (
                                            <tr key={index}
                                            //style={{ backgroundColor: '#f9f9fb' }}
                                            >
                                                <td style={{ padding: '10px', width: '22%' }}>{index + 1}</td>
                                                <td style={{ padding: '10px', width: '40%' }}>{item.dairy.name}</td>
                                                <td style={{ padding: '10px', width: '38%' }}>{calculate(item.quantity, inputValue.aTotalPerson, item.unitType)}</td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </>)}


                            {AfternoonData.farsan && AfternoonData.farsan.length > 0 && (<>
                                <div style={{
                                    fontWeight: 'bold',
                                    paddingTop: '5px',
                                    paddingBottom: '5px',
                                    fontSize: '14px',
                                    display: 'flex',
                                    justifyContent: 'center',
                                    // backgroundColor: '#4f726c',
                                    color: '#000000',
                                    marginTop: '20px'
                                }}>
                                    {t('FarsanItems')}
                                </div>
                                <table style={{ width: '100%', fontSize: '12px' }}>
                                    <thead>
                                        <tr style={{
                                            //backgroundColor: '#14312c',
                                            color: '#000000'
                                        }}>
                                            <th style={{ padding: '10px', textAlign: 'left', width: '22%' }}>{t('no')}</th>
                                            <th style={{ padding: '10px', textAlign: 'left', width: '40%' }}>{t('item')}</th>
                                            <th style={{ padding: '10px', textAlign: 'left', width: '38%' }}>{t('Quantity')}</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {AfternoonData.farsan.map((item, index) => (
                                            <tr key={index}
                                            //style={{ backgroundColor: '#f9f9fb' }}
                                            >
                                                <td style={{ padding: '10px', width: '22%' }}>{index + 1}</td>
                                                <td style={{ padding: '10px', width: '40%' }}>{item.farsan.name}</td>
                                                <td style={{ padding: '10px', width: '38%' }}>{calculate(item.quantity, inputValue.aTotalPerson, item.unitType)}</td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </>)}

                            {AfternoonData.vasan && AfternoonData.vasan.length > 0 && (<>
                                <div style={{
                                    fontWeight: 'bold',
                                    paddingTop: '5px',
                                    paddingBottom: '5px',
                                    fontSize: '14px',
                                    display: 'flex',
                                    justifyContent: 'center',
                                    //backgroundColor: '#4f726c',
                                    color: '#000000',
                                    marginTop: '20px'
                                }}>
                                    {t('VasanItems')}
                                </div>
                                <table style={{ width: '100%', fontSize: '12px' }}>
                                    <thead>
                                        <tr style={{
                                            // backgroundColor: '#14312c', 
                                            color: '#000000'
                                        }}>
                                            <th style={{ padding: '10px', textAlign: 'left', width: '22%' }}>{t('no')}</th>
                                            <th style={{ padding: '10px', textAlign: 'left', width: '40%' }}>{t('item')}</th>
                                            <th style={{ padding: '10px', textAlign: 'left', width: '38%' }}>{t('Quantity')}</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {AfternoonData.vasan.map((item, index) => (
                                            <tr key={index}
                                            //style={{ backgroundColor: '#f9f9fb' }}
                                            >
                                                <td style={{ padding: '10px', width: '22%' }}>{index + 1}</td>
                                                <td style={{ padding: '10px', width: '40%' }}>{item.vasan.name}</td>
                                                <td style={{ padding: '10px', width: '38%' }}>{calculate(item.quantity, inputValue.aTotalPerson, item.unitType)}</td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </>)}
                            {/* </>))} */}
                        </div>
                    </div>

                    {nightSelectedOptions && nightSelectedOptions.length > 0 &&
                        <div style={{ pageBreakBefore: 'always' }}></div>}

                </>)}

            {NightData && (NightData.dairy.length > 0 ||
                NightData.vegetable.length > 0 ||
                NightData.farsan.length > 0 ||
                NightData.grocery.length > 0 ||
                NightData.vasan.length > 0) && (<>
                    <div style={{
                        display: 'flex',
                        flexWrap: 'wrap',
                        color: '#000000',
                        justifyContent: 'space-between',
                        border: '2px solid #14312c',
                        // backgroundColor: '#4f726c'
                    }}>
                        <div style={{ width: '78%' }}>
                            <div style={{
                                marginBottom: '0px',
                                padding: '0px',
                                paddingTop: '15px',
                                display: 'flex',
                                justifyContent: 'space-between',
                                flexWrap: 'wrap',
                                fontSize: '14px',
                            }}>
                                <div style={{ paddingLeft: '15px', width: '46%', marginBottom: '10px' }}><strong>{t('Farm_Name')}:</strong> {selectedOrder.farmName}</div>
                                <div style={{ paddingRight: '15px', width: '46%', marginBottom: '10px' }}><strong>{t('Party_Name')}:</strong> {selectedOrder.partyName}</div>
                                <div style={{ paddingLeft: '15px', width: '46%', marginBottom: '10px' }}><strong>{t('Contact_Number')}:</strong> {selectedOrder.contactNumber}</div>
                                <div style={{ paddingRight: '15px', width: '46%', marginBottom: '10px' }}><strong>{t('Event_Date')}:</strong> {moment(selectedOrder.eventDate).format('DD-MM-YYYY')}</div>
                                <div style={{ width: '100%', paddingLeft: '15px', paddingRight: '15px', marginBottom: '10px' }}><strong>{t('Farm_Address')}:</strong> {selectedOrder.farmAddress}</div>
                            </div>
                        </div>
                        <div style={{
                            width: '20%',
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                            marginRight: '3px'
                        }}>
                            <div style={{ textAlign: 'center' }}>
                                <img src={pdflogoSrc} alt='Logo' style={{ width: '100px' }} />
                            </div>
                        </div>

                        <div style={{
                            display: 'flex',
                            flexWrap: 'wrap',
                            // backgroundColor: '#14312c',
                            width: '100%',
                            justifyContent: 'space-between',
                            padding: '10px 15px',
                            margin: 'auto',
                            marginBottom: '0px'
                        }}>
                            <div style={{ marginBottom: '0px' }}>
                                <strong>{moment(selectedOrder.eventDate).format('DD-MM-YYYY')} :</strong> - {t('Night')}
                            </div>
                            <div style={{ marginBottom: '0px' }}>
                                <strong>{t('dish')} :-</strong> {inputValue.nTotalPerson ? inputValue.nTotalPerson : 0}
                            </div>
                        </div>
                    </div>

                    <div style={{ margin: '10px 0' }} >
                        <div style={{ padding: '15px 0px' }} class="menu-items">
                            {/* {nightSelectedOptions.map((element, indx) => (<> */}
                            {/* <div style={{ fontWeight: 'bold', paddingTop: '5px', paddingBottom: '5px', fontSize: '16px' }}>
                                {indx + 1 + '.'} {element.menuName}
                            </div> */}

                            {NightData.vegetable && NightData.vegetable.length > 0 && (<>
                                <div style={{
                                    fontWeight: 'bold',
                                    paddingTop: '5px',
                                    paddingBottom: '5px',
                                    fontSize: '14px',
                                    display: 'flex',
                                    justifyContent: 'center',
                                    // backgroundColor: '#4f726c',
                                    color: '#000000'
                                }}>
                                    {t('vegetable')}
                                </div>
                                <table style={{ width: '100%', fontSize: '12px' }}>
                                    <thead>
                                        <tr style={{
                                            // backgroundColor: '#14312c',
                                            color: '#000000'
                                        }}>
                                            <th style={{ padding: '10px', textAlign: 'left', width: '22%' }}>{t('no')}</th>
                                            <th style={{ padding: '10px', textAlign: 'left', width: '40%' }}>{t('item')}</th>
                                            <th style={{ padding: '10px', textAlign: 'left', width: '38%' }}>{t('Quantity')}</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {NightData.vegetable.map((item, index) => (
                                            <tr key={index}
                                            //style={{ backgroundColor: '#f9f9fb' }}
                                            >
                                                <td style={{ padding: '10px', width: '22%' }}>{index + 1}</td>
                                                <td style={{ padding: '10px', width: '40%' }}>{item.vegetable.name}</td>
                                                <td style={{ padding: '10px', width: '38%' }}>{calculate(item.quantity, inputValue.nTotalPerson, item.unitType)}</td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </>)}

                            {NightData.grocery && NightData.grocery.length > 0 && (<>
                                <div style={{
                                    fontWeight: 'bold',
                                    paddingTop: '5px',
                                    paddingBottom: '5px',
                                    fontSize: '14px',
                                    display: 'flex',
                                    justifyContent: 'center',
                                    // backgroundColor: '#4f726c',
                                    color: '#000000',
                                    marginTop: '20px'
                                }}>
                                    {t('Groceries')}
                                </div>
                                <table style={{ width: '100%', fontSize: '12px' }}>
                                    <thead>
                                        <tr style={{
                                            // backgroundColor: '#14312c',
                                            color: '#000000'
                                        }}>
                                            <th style={{ padding: '10px', textAlign: 'left', width: '22%' }}>{t('no')}</th>
                                            <th style={{ padding: '10px', textAlign: 'left', width: '40%' }}>{t('item')}</th>
                                            <th style={{ padding: '10px', textAlign: 'left', width: '38%' }}>{t('Quantity')}</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {NightData.grocery.map((item, index) => (
                                            <tr key={index}
                                            //style={{ backgroundColor: '#f9f9fb' }}
                                            >
                                                <td style={{ padding: '10px', width: '22%' }}>{index + 1}</td>
                                                <td style={{ padding: '10px', width: '40%' }}>{item.grocery.name}</td>
                                                <td style={{ padding: '10px', width: '38%' }}>{calculate(item.quantity, inputValue.nTotalPerson, item.unitType)}</td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </>)}

                            {NightData.dairy && NightData.dairy.length > 0 && (<>
                                <div style={{
                                    fontWeight: 'bold',
                                    paddingTop: '5px',
                                    paddingBottom: '5px',
                                    fontSize: '14px',
                                    display: 'flex',
                                    justifyContent: 'center',
                                    // backgroundColor: '#4f726c',
                                    color: '#000000',
                                    marginTop: '20px'
                                }}>
                                    {t('DairyItems')}
                                </div>
                                <table style={{ width: '100%', fontSize: '12px' }}>
                                    <thead>
                                        <tr style={{
                                            // backgroundColor: '#14312c',
                                            color: '#000000'
                                        }}>
                                            <th style={{ padding: '10px', textAlign: 'left', width: '22%' }}>{t('no')}</th>
                                            <th style={{ padding: '10px', textAlign: 'left', width: '40%' }}>{t('item')}</th>
                                            <th style={{ padding: '10px', textAlign: 'left', width: '38%' }}>{t('Quantity')}</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {NightData.dairy.map((item, index) => (
                                            <tr key={index}
                                            //style={{ backgroundColor: '#f9f9fb' }}
                                            >
                                                <td style={{ padding: '10px', width: '22%' }}>{index + 1}</td>
                                                <td style={{ padding: '10px', width: '40%' }}>{item.dairy.name}</td>
                                                <td style={{ padding: '10px', width: '38%' }}>{calculate(item.quantity, inputValue.nTotalPerson, item.unitType)}</td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </>)}


                            {NightData.farsan && NightData.farsan.length > 0 && (<>
                                <div style={{
                                    fontWeight: 'bold',
                                    paddingTop: '5px',
                                    paddingBottom: '5px',
                                    fontSize: '14px',
                                    display: 'flex',
                                    justifyContent: 'center',
                                    //backgroundColor: '#4f726c',
                                    color: '#000000',
                                    marginTop: '20px'
                                }}>
                                    {t('FarsanItems')}
                                </div>
                                <table style={{ width: '100%', fontSize: '12px' }}>
                                    <thead>
                                        <tr style={{
                                            //backgroundColor: '#14312c', 
                                            color: '#000000'
                                        }}>
                                            <th style={{ padding: '10px', textAlign: 'left', width: '22%' }}>{t('no')}</th>
                                            <th style={{ padding: '10px', textAlign: 'left', width: '40%' }}>{t('item')}</th>
                                            <th style={{ padding: '10px', textAlign: 'left', width: '38%' }}>{t('Quantity')}</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {NightData.farsan.map((item, index) => (
                                            <tr key={index}
                                            //style={{ backgroundColor: '#f9f9fb' }}
                                            >
                                                <td style={{ padding: '10px', width: '22%' }}>{index + 1}</td>
                                                <td style={{ padding: '10px', width: '40%' }}>{item.farsan.name}</td>
                                                <td style={{ padding: '10px', width: '38%' }}>{calculate(item.quantity, inputValue.nTotalPerson, item.unitType)}</td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </>)}

                            {NightData.vasan && NightData.vasan.length > 0 && (<>
                                <div style={{
                                    fontWeight: 'bold',
                                    paddingTop: '5px',
                                    paddingBottom: '5px',
                                    fontSize: '14px',
                                    display: 'flex',
                                    justifyContent: 'center',
                                    // backgroundColor: '#4f726c',
                                    color: '#000000',
                                    marginTop: '20px'
                                }}>
                                    {t('VasanItems')}
                                </div>
                                <table style={{ width: '100%', fontSize: '12px' }}>
                                    <thead>
                                        <tr style={{
                                            //backgroundColor: '#14312c',
                                            color: '#000000'
                                        }}>
                                            <th style={{ padding: '10px', textAlign: 'left', width: '22%' }}>{t('no')}</th>
                                            <th style={{ padding: '10px', textAlign: 'left', width: '40%' }}>{t('item')}</th>
                                            <th style={{ padding: '10px', textAlign: 'left', width: '38%' }}>{t('Quantity')}</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {NightData.vasan.map((item, index) => (
                                            <tr key={index}
                                            //style={{ backgroundColor: '#f9f9fb' }}
                                            >
                                                <td style={{ padding: '10px', width: '22%' }}>{index + 1}</td>
                                                <td style={{ padding: '10px', width: '40%' }}>{item.vasan.name}</td>
                                                <td style={{ padding: '10px', width: '38%' }}>{calculate(item.quantity, inputValue.nTotalPerson, item.unitType)}</td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </>)}
                            {/* </>))} */}
                        </div>
                    </div>

                </>)}

        </div>
    )
}

export default ViewMaterial